export default function About() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Formando Líderes Cristãos com Excelência
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                O ICMI existe desde 2017 e já formou mais de 300 alunos comprometidos com o ministério cristão e a expansão do Reino de Deus.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Nossa missão é capacitar líderes cristãos com excelência teológica e prática ministerial, ajudando igrejas a formar sua liderança através de cursos completos e mentorias personalizadas.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Atuamos diretamente em parceria com igrejas, oferecendo formação de qualidade com apostilas, certificação e acompanhamento personalizado nas modalidades presencial e online.
              </p>
              
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-3 bg-teal-50 px-6 py-3 rounded-lg">
                  <i className="ri-book-open-line text-teal-600 text-2xl"></i>
                  <span className="text-gray-800 font-medium">Apostilas Completas</span>
                </div>
                <div className="flex items-center gap-3 bg-teal-50 px-6 py-3 rounded-lg">
                  <i className="ri-award-line text-teal-600 text-2xl"></i>
                  <span className="text-gray-800 font-medium">Certificação</span>
                </div>
                <div className="flex items-center gap-3 bg-teal-50 px-6 py-3 rounded-lg">
                  <i className="ri-user-heart-line text-teal-600 text-2xl"></i>
                  <span className="text-gray-800 font-medium">Mentoria Personalizada</span>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="w-full h-96 rounded-lg overflow-hidden shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/80821a7127edf6626cb7d3e082946c04/2b058841ca479d2f378f606aebbf5a66.jpeg"
                  alt="Formatura ICMI - Momento do juramento dos teólogos formados"
                  title="Formandos do ICMI no momento solene do juramento"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-lg shadow-xl">
                <div className="text-5xl font-bold mb-2">300+</div>
                <div className="text-sm font-medium">Alunos Formados</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
